<template>
  <div class="BulkOrderbysea">
    <h4>{{ $t("i18n_LTL_order") }}</h4>
    <el-form
      ref="OrderQueryConditions"
      :label-position="labelPosition"
      :model="OrderQueryConditions"
    >
      <el-form-item :label="$t('i18n_tracking_number')">
        <el-input
          v-model="OrderQueryConditions.OrderCode"
          :placeholder="$t('i18n_please_enter')"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('i18n_receving_warehosue')">
        <el-select
          v-model="OrderQueryConditions.InwareHouse"
          :placeholder="$t('i18n_please_choose')"
        >
          <el-option
            :label="$t(item.namec)"
            :value="item.id"
            v-for="(item, index) in warehouseList"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="">
        <el-select style="visibility: hidden">
          <el-option></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item :label="$t('i18n_delivery_area')">
        <el-cascader
          clearable
          :placeholder="$t('i18n_please_choose')"
          style="width: 200px"
          ref="changetoFABck"
          v-model="selectedHouseList"
          :options="houseList"
          :props="toFBAdataprops"
        >
          <template slot-scope="{ node, data }">
            <span>{{ data.namec }}</span>
            <span v-if="!node.isLeaf"></span>
          </template>
        </el-cascader>
      </el-form-item>
      <el-form-item :label="$t('i18n_Order_date')">
        <el-date-picker
          v-model="OrderQueryConditions.EntrustmentData"
          type="daterange"
          range-separator="-"
          :start-placeholder="$t('i18n_started_date')"
          :end-placeholder="$t('i18n_end_date')"
        >
        </el-date-picker>
      </el-form-item>
      <el-button type="primary" @click="onSubmit">{{
        $t("i18n_tracking")
      }}</el-button>
    </el-form>
    <el-tabs v-model="activeName" @tab-click="handleClick(activeName)">
      <el-tab-pane
        :label="item.staus_desc"
        :name="item.order_status"
        v-for="(item, key) in tabsList"
        :key="key"
      >
        <el-table
          border
          align="center"
          :data="tableData"
          max-height="580"
          tooltip-effect="dark"
          :header-cell-style="{ background: '#F3F3F3' }"
          ref="multipleTable"
          style="width: 95%; margin-left: 32px"
          @selection-change="handleSelectionChange"
        >
          <!-- <el-table-column type="selection" label="全选" min-width="5%"></el-table-column> -->
          <el-table-column
            type="index"
            :label="$t('i18n_Serial_number')"
            width="60px"
          ></el-table-column>
          <el-table-column
            prop="nos"
            :label="$t('i18n_tracking_number')"
            width="150px"
          ></el-table-column>
          <el-table-column
            prop="warehousename"
            :label="$t('i18n_receving_warehosue')"
            show-overflow-tooltip
            width="150px"
          ></el-table-column>
          <el-table-column
            prop="GoodsMessage"
            :label="$t('i18n_shipment_information')"
            show-overflow-tooltip
            width="250px"
          ></el-table-column>
          <el-table-column
            prop="Warehousing"
            :label="$t('i18n_shipment_information')"
            show-overflow-tooltip
            width="250px"
          ></el-table-column>
          <el-table-column
            prop="EstimatedCost"
            :label="$t('i18n_estimated_cost')"
            width="130px"
          ></el-table-column>
          <el-table-column
            prop="ActualCosts"
            :label="$t('i18n_Estimate_inWarehouse_cost')"
            show-overflow-tooltip
            width="150px"
          >
            <div slot="header">
              {{ $t("i18n_Estimate_inWarehouse_cost") }}
              <el-tooltip
                :content="$t('actual_fee_after_loading')"
                placement="top"
              >
                <i class="el-icon-question"></i>
              </el-tooltip>
            </div>
          </el-table-column>
          <el-table-column
            prop="status"
            :label="$t('i18n_Tracking')"
            show-overflow-tooltip
            width="280px"
          ></el-table-column>
          <!-- <el-table-column
            prop="job_status"
            label="状态"
            min-width="10%"
          >
          </el-table-column> -->
          <el-table-column
            prop="createTime"
            :label="$t('i18n_creation_time')"
            show-overflow-tooltip
            width="200px"
          ></el-table-column>
          <el-table-column
            prop="operation"
            :label="$t('i18n_Operation')"
            align="center"
            :width="typeCode == 'G' ? '200px' : '120px'"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-button
                v-if="!scope.row.replenishComplete"
                @click="addGoods(scope.row)"
                type="text"
                >{{ $t("i18n_shipment_instruction") }}</el-button
              >
              <el-button
                v-else
                @click="orderdetails(scope)"
                type="text"
                size="small"
                >{{ $t("i18n_view_details") }}</el-button
              >
              <el-button
                @click="getConsign(scope.row)"
                type="text"
                size="small"
                v-if="scope.row.attachmentsign && typeCode == 'G'"
              >
                查看签收单
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <div style="">
      <el-pagination
        style="margin: 20px; margin-left: 32px; float: left"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="curPageL"
        :pager-count="5"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <!-- 文件预览 -->
    <viewOrder
      @closeFileDia="closeDiaView"
      :fileVisible="viewVisible"
      :tableData="fileList"
    ></viewOrder>
  </div>
</template>

<script>
import qs from "qs";
import viewOrder from "../components/viewOrder.vue";
export default {
  name: "BulkOrderbysea",
  components: { viewOrder },
  data() {
    return {
      //文件预览弹窗
      viewVisible: false,
      // 附件数据
      fileList: [],
      selectedHouseList: [],
      toFBAdataprops: {
        label: "namec",
        value: "id",
        // children: "datWarehouseDTOList",
        children: "children",
      },
      houseList: [],
      total: 1000, //总条数
      pagesize: 10, //每页显示条数
      prefix: "",
      labelPosition: "left",
      activeName: "Z",
      tabsList: [
        { staus_desc: "全部", order_status: "Z" },
        { staus_desc: "待入仓", order_status: "A2" },
        { staus_desc: "已入仓", order_status: "B" },
        { staus_desc: "运输中", order_status: "C" },
        { staus_desc: "已到港", order_status: "D" },
        { staus_desc: "已到仓", order_status: "E" },
        { staus_desc: "派送中", order_status: "F" },
        { staus_desc: "已派送", order_status: "G" },
        { staus_desc: "已完成", order_status: "H" },
        { staus_desc: "待付款", order_status: "I" },
      ],
      tabListdata: [], //表单表头
      OrderQueryConditions: {
        //表单
        OrderCode: "", //运单号
        InwareHouse: "", //入仓仓库
        DestinationCountry: "", //目的国家
        DistributionArea: "", //配送区域
        EntrustmentData: [], //委托日期
      },
      tableData: [
        //table值
        // {
        //   "nos":"",//运单号
        //   "warehousename":"",//入仓仓库
        //   "GoodsMessage":"",//货物信息
        //   "Warehousing":"",//入仓信息
        //   "EstimatedCost":"",//预估费用
        //   "ActualCosts":"",//实际费用
        //   "job_status":"",//轨迹
        //   "state":"",//状态
        //   "operation":""//操作
        // }
      ],
      customerid: "", //运单号
      typeCode: "Z", //查询类型
      curPageL: 1,
      warehouseList: [], //仓库列表

      distributionList: [], //配送目的列表
    };
  },
  watch: {},
  methods: {
    /**
     * 关闭签收单弹窗
     * */
    closeDiaView() {
      this.viewVisible = false
      this.fileList = []
    },
    /**
     * 海运散货获取签收单
     * @param row 行数据
     * */
    getConsign(row) {
      if (!!row.jobid) {
        this.axios
          .get(`/finance/getPodAttachments?jobid=${row.jobid}`)
          .then(res => {
            console.log("签收单详情", res)
            if (res.data.code == 200) {
              if (Array.isArray(res.data.data.attachments) && res.data.data.attachments.length > 0) {
                this.fileList = res.data.data.attachments
                this.viewVisible = true
              } else {
                this.$message.warning("暂无数据")
              }
            } else {
              this.$message.warning("数据异常,请稍候再试或联系管理员")
            }
          })
      } else {
        this.$message.warning("数据异常,请稍候再试或联系管理员")
      }

    },
    handleSelectionChange(val) {
      //table方法
      this.multipleSelection = val;
    },
    tableDatas(list) {
      //接口数据对接table
      this.tableData = [];
      for (var i = 0; i < list.length; i++) {
        this.tableData.push(list[i]);
        this.tableData[i].GoodsMessage =
          list[i].goodescbefore +
          " " +
          list[i].goodcbmbefore +
          "CBM " +
          list[i].goodweightbefore +
          "KG";
        this.tableData[i].Warehousing =
          list[i].goodesc +
          " " +
          list[i].goodcbm +
          "CBM " +
          list[i].goodweight +
          "KG";
        this.tableData[i].EstimatedCost = this.tableData[
          i
        ].costbeforeinfo.amount1;
        this.tableData[i].ActualCosts = this.tableData[i].costinfo.amount2;
        if (this.tableData[i].state == 1) {
          this.tableData[i].Warehousing = "";
        }
      }
    },
    orderdetails(data) {
      //查看详情点击
      this.$router.push({
        name: "OrderDetails",
        query: { state: data.row.state, nos: data.row.nos },
      });
    },
    onSubmit() {
      //点击查询方法
      this.curPageL = 1;
      this.getAllOrder();
    },
    handleClick(activeName) {
      //tabs标签切换
      this.typeCode = activeName;
      console.log("this.typeCode", this.typeCode)
      this.getAllOrder(); //切换tabs
    },
    handleSizeChange(val) {
      //分页每页多少条
      this.pagesize = val;
      if (this.tabListdata.length > 0) {
        this.getAllOrder();
      }
    },
    handleCurrentChange(val) {
      //分页当前页
      this.curPageL = val;
      if (this.tabListdata.length > 0) {
        this.getAllOrder();
      }
    },
    warehouse() {
      //仓库id获取
      this.axios
        .get("/warehouse/warehouseListAll")
        .then((response) => {
          this.warehouseList = response.data.datas;
          let newda = {
            namec: "i18n_All",
            id: "",
          };
          this.warehouseList.splice(0, 0, newda);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    territory() {
      //目的国家以及配送区域的id获取
      this.axios
        // .get("/warehouse/overseasWarehouseList")
        .get("/filedata/listLevelPodCity?busType=L")
        .then((res) => {
          this.houseList = res.data.datas
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getAllOrder() {
      //获取全部订单
      if (this.OrderQueryConditions.DistributionArea == "全部") {
        this.OrderQueryConditions.DistributionArea = "";
      }
      if (this.OrderQueryConditions.EntrustmentData == null) {
        this.OrderQueryConditions.EntrustmentData = ["", ""];
      }
      let data = {
        area: this.selectedHouseList[1], //配送区域
        beginTime: this.OrderQueryConditions.EntrustmentData[0]
          ? this.OrderQueryConditions.EntrustmentData[0]
          : "", //开始时间
        countryId: this.OrderQueryConditions.DestinationCountry, //国家id
        curPage: this.curPageL, //当前页，默认1
        customerid: this.customerid, //客户id
        endTime: this.OrderQueryConditions.EntrustmentData[1]
          ? this.OrderQueryConditions.EntrustmentData[1]
          : "", //结束时间
        language: "CN",
        nos: this.OrderQueryConditions.OrderCode, //运单号
        pageSize: this.pagesize, //每页数量，默认20
        type: this.typeCode, //运单状态类型
        warehouseid: this.OrderQueryConditions.InwareHouse, //仓库id
      };
      // console.log(data);
      let that = this;
      that.axios
        .post("/finance/getLclJobsHistoryWebList", data)
        .then(function (response) {
          // console.log(response.data.data);
          that.tabListdata = [];
          that.tabListdata = response.data.data.orderList;
          that.tableDatas(that.tabListdata);
          that.total = Number(response.data.data.totalCounts);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getPansonageOrder() {
      //获取个人表头信息
      // let data = {
      //   customerid: this.customerid,
      //   jobtype: "C",
      //   language: "CN",
      // };
      this.axios
        .get(`/finance/getLclJobWebCount/${this.customerid}`)
        .then((response) => {
          let datas = response.data.data.statusList;
          this.tabsList = [];
          for (var i = 0; i < datas.length; i++) {
            this.tabsList.push(datas[i]);
            this.tabsList[i].staus_desc =
              datas[i].staus_desc + "(" + datas[i].counts + ")";
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    addGoods(item) {
      this.$router.push({
        name: 'editBulkOrder',
        query: { innos: item.nos }
      })
    }
  },
  created() {
    let publics = JSON.parse(sessionStorage.getItem("Authorization"));
    this.customerid = publics.customerid;
  },
  mounted() {
    this.getAllOrder();
    this.warehouse();
    this.territory();
    this.getPansonageOrder();
  },
};
</script>
<style scoped>
.el-table >>> th.gutter {
  display: table-cell !important;
}
.el-table th.gutter {
  display: table-cell !important;
}
.BulkOrderbysea {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
}
.BulkOrderbysea h4 {
  font-size: 24px;
  font-family: "PingFang-SC-Bold";
  color: #343434;
  padding-left: 32px;
  padding-top: 32px;
}
/* .BulkOrderbysea h4 {
  width: 100%;
  height: 24px;
  padding-top: 30px;
  padding-left: 31px;
  font-size: 24px;
  font-family: "PingFang-SC-Bold";
  color: #343434;
} */
.BulkOrderbysea footer {
  width: 100%;
  height: 35px;
  margin-top: 10px;
  position: relative;
  box-sizing: border-box;
}
.BulkOrderbysea .el-form {
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 32px;
  padding-left: 32px;
}
.BulkOrderbysea .el-form-item {
  display: flex;
  height: 32px;
  margin: 0;
}
.BulkOrderbysea >>> .el-input__inner {
  width: 217px;
  height: 32px !important;
  line-height: 32px;
}

.BulkOrderbysea >>> .el-pagination {
  display: flex;
  align-items: center;
  height: 32px;
  padding: 0px;
}

.BulkOrderbysea >>> .el-pagination .el-input__inner {
  width: 100px;
  height: 32px !important;
  line-height: 32px;
}
.BulkOrderbysea >>> .el-pagination__jump {
  height: 32px;
  line-height: 32px;
}

.BulkOrderbysea >>> .is-in-pagination .el-input__inner {
  width: 44px;
}

.BulkOrderbysea >>> .el-form-item__content {
  line-height: 32px;
}

.BulkOrderbysea >>> .el-input__icon {
  line-height: 32px;
}

.BulkOrderbysea >>> .el-cascader {
  line-height: 32px;
}

.BulkOrderbysea >>> .el-form-item__label {
  height: 32px;
  line-height: 32px;
}

.BulkOrderbysea >>> .el-button {
  box-sizing: border-box;
  height: 32px;
  line-height: 32px;
  margin: 0;
  padding: 0;
  width: 72px;
}

.BulkOrderbysea >>> .el-date-editor {
  width: 262px;
  height: 32px !important;
  padding: 0px;
  padding-left: 12px;
}

/* footer .el-pagination{
  position: absolute;
  right: 50px;
  width: 620px;
  box-sizing: border-box;
} */
/* .BulkOrderbysea .el-form {
  margin-top: 20px;
  margin-left: 31px;
}
.BulkOrderbysea .el-form .el-input {
  width: 68%;
  height: 38px;
  line-height: 38px;
  background: #ffffff;
  border-color: #e7e7e7;
  border-radius: 5px;
}
.BulkOrderbysea .el-form .el-input--suffix {
  width: 100%;
}
.BulkOrderbysea .el-select {
  width: 68%;
}
.BulkOrderbysea .el-date-editor--daterange.el-input,
.BulkOrderbysea .el-date-editor--daterange.el-input__inner,
.BulkOrderbysea .el-date-editor--timerange.el-input,
.BulkOrderbysea .el-date-editor--timerange.el-input__inner {
  width: 68%;
}
.BulkOrderbysea .el-form-item,
.el-form-item--small.el-form-item {
  width: 33%;
  display: inline-block;
}
.BulkOrderbysea .el-button--primary {
  width: 102px;
  height: 36px;
  padding: 0;
  border-radius: 5px;
  border: none;
} */
.BulkOrderbysea .el-tabs__header {
  margin: 0px 30px 15px;
}
.BulkOrderbysea .el-tabs__nav-wrap::after {
  background: none;
}
.BulkOrderbysea >>> .el-table td,
.BulkOrderbysea >>> .el-table th {
  padding: 3px 0;
  text-align: center;
}
.BulkOrderbysea .el-tabs__item.is-active {
  color: #343434;
}
.BulkOrderbysea .el-tabs__item {
  color: #9a9a9a;
}
.BulkOrderbysea .el-table__body-wrapper {
  height: 530px !important;
}
/* table 滚动条 */
.BulkOrderbysea .el-table__body-wrapper::-webkit-scrollbar {
  width: 3px;
}
.BulkOrderbysea .el-table__body-wrapper::-webkit-scrollbar-thumb {
  border-radius: 2px;
  height: 50px;
  background: #409eff;
}
.BulkOrderbysea .el-table__body-wrapper::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 2px;
  background: #eee;
}
</style>



// WEBPACK FOOTER //
// src/components/PersonalCenter/BulkOrder/BulkOrderbysea.vue